export type ClassroomContentTab = 'QUIZSET' | 'BOARD';
const studentList = (classroomId: string) =>
  `/classrooms/${classroomId}/students` as const;

const content = (classroomId: string, tab: ClassroomContentTab) =>
  `/classrooms/${classroomId}/${
    tab === 'QUIZSET' ? 'quizzes' : 'boards'
  }` as const;

export const CLASSROOM_ROUTES = {
  list: () => '/classrooms' as const,
  /**
   * 클래스 진입 경로. 호출자가 사용자의 소유 여부를 알고 있으면
   * `isOwner` 를 넘겨 role-resolution hop 을 건너뛴다. owner 의 기본 진입은
   * students 이지만, 모바일에서는 콘텐츠 탭(quizzes)을 먼저 보여준다. 모르면
   * `/classrooms/{id}` 로 진입해 `ClassroomDetailPageView` 가 클라이언트에서
   * role/viewport 를 조회해 올바른 경로로 replace 한다.
   */
  detail: (
    classroomId: string,
    isOwner?: boolean,
    options?: { isMobile?: boolean },
  ): string => {
    if (isOwner === true) {
      return options?.isMobile
        ? content(classroomId, 'QUIZSET')
        : studentList(classroomId);
    }
    if (isOwner === false) return content(classroomId, 'QUIZSET');
    return `/classrooms/${classroomId}`;
  },
  studentList,
  studentDetail: (classroomId: string, userId: string) =>
    `/classrooms/${classroomId}/students/${encodeURIComponent(
      userId,
    )}` as const,
  content,
  join: (classroomId: string, code?: string) =>
    code
      ? (`/classrooms/${classroomId}/join?code=${encodeURIComponent(
          code,
        )}` as const)
      : (`/classrooms/${classroomId}/join` as const),
} as const;
